import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { IconButton, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import Select from 'react-select'
import { ConfigContext } from '../../Context/ConfigContext'
import { currentDateAndTime, decodeData } from '../../Constants/constants';
import { NoRecords } from '../../Components/Shimmer';
class Department extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            department_id: 0,
            hod_employee_id: 0,
            keyword: '',
            department_title: '',
            department_description: '',
            rows: [],
            errors: {},
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            employee_verified_row: [],
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            postLoading: false,
            loadingInfo: false,
            loadingDelete: false,
            decodedData: [],
            isDepartmentModal: false,

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetEmployeesVerifiedList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }),()=>{
            if(name === "keyword" && !value) this.GetList();
        });
    };
    GetInfo = (row) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        this.setState({ loadingInfo: row?.department_id });
        axios.get(`${apiURL}Masters/GetDepartmentInfo?department_id=${row.department_id}`, { headers })
        .then((response) => {
            const { data, success } = response.data;
            if (success === true) {
                this.setState(
                    {
                        isDepartmentModal: true,
                        department_id: data[0]?.department_id,
                        hod_employee_id: data[0]?.hod_employee_id,
                        department_title: data[0]?.department_title,
                        department_description: data[0]?.department_description,
                        errors:{
                            ...this.state.errors,
                            department_title:'',
                            department_description:'',
                        }
                    }
                )
            }
            this.setState({ loadingInfo: false });
        })
        .catch((error)=>{
            this.setState({ loadingInfo: false });
        });
         
    }


    GetEmployeesVerifiedList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
            .then((response) => {
                var data = response.data;
                if (response.data.success === true) {
                    this.setState((prevState) => ({
                        employee_verified_row: data.data.map((row) => ({
                            value: row.employee_id,
                            label: row.employee_name
                        }))
                    }));
                }
            });
    }

    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetDepartments`, { params: { keyword: this.state.keyword, limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors, postLoading: false });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        var formData = {

            hod_employee_id: this.state.hod_employee_id,
            department_title: this.state.department_title,
            department_description: this.state.department_description,
            date: currentDateAndTime()
        }
        if (this.state.department_id !== 0) {
            formData.department_id = this.state.department_id;
        }

        axios
            .post(`${apiURL}Masters/CreateDepartment`, formData, { headers })
            .then((response) => {
                const { success } = response.data;
                if (success === true) {
                    this.resetForm();

                    this.setState({ loadingList: true, postLoading: false }, (prevState) => {
                        this.GetList();
                    })
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        // timer: 2000,
                        allowOutsideClick: false,
                        showConfirmButton: true,
                    })
                } else {
                    Swal.fire({
                        title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: response.data.success === true ? 'success' : 'error',
                        // timer: 2000,
                        allowOutsideClick: true,
                        showConfirmButton: true,
                    })
                    this.setState({ loadingList: false, postLoading: false });
                }

            })
            .catch((error)=>{
                this.setState({ loadingList: false, postLoading: false });
            })
    };
    resetForm = () => {
        this.setState({
            department_id: 0,
            hod_employee_id: 0,
            department_title: '',
            department_description: ''
        })

    }
    validateForm = () => {
        const errors = {};

        if (!this.state.department_title) {
            errors.department_title = 'Department title is required';
        }
        if (!this.state.department_description) {
            errors.department_description = 'Department description is required';
        }

        return errors;
    };
    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true, loadingDelete: true });
                const formData = {
                    department_id: id,
                    date: currentDateAndTime()
                };
                axios
                    .post(`${apiURL}Masters/DeleteDepartment`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            // timer: 1000,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        })
                        this.setState({ status: false, loadingDelete: false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    })
                    .catch((error) => {
                        this.setState({ status: false, loadingDelete: false });
                        Swal.fire({
                            title: <strong>Error</strong>,
                            html: error,
                            icon: 'error'
                        })
                    });
            }
        });
    }

    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {
        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }
    handleLimitChange = (e) => {
        this.setState(
        {
            limit: parseInt(e.target.value, 10),
            page: 1,
        },
        () => {
            this.GetList();
        }
        );
    };
    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };
    handleInputSearch = () => {
        this.GetList();
    }
    handleClearAll = () => {
        this.setState({keyword: "",}, () => {this.GetList();});
    };


    render() {
        const { errors } = this.state;
        const limitOptions = [10, 25, 50, 100, 200, 500];
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`Departments`} primary={`Home`} />
                        <div className='card'>
                            <div className=" card-body pb-0 align-items-end justify-content-between d-flex">
                                <div className='  '>
                                    <label htmlFor="keyword">Department Title</label>
                                    <div className="input-group">
                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Department" />
                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button"><i className="ri-search-line"></i></button>
                                        <button className="btn btn-secondary ms-3" disabled={!this.state.keyword} onClick={this.handleClearAll} type="button">Clear</button>
                                    </div>
                                </div>
                                { this.state.decodedData?.includes(2) && (
                                <div className=''>
                                    <button style={{ float: "right"}} onClick={()=>{ this.setState({ department_id:0, isDepartmentModal:true }) }} className={`btn btn-success btn-label `} >
                                        <span className="d-flex align-items-center gap-1">
                                        <i className={` ri-play-list-add-line label-icon align-middle fs-16`} />
                                        Add
                                    </span>
                                    </button>
                                </div>)}
                            </div>
                            <div className="card-body">
                                <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className=" ">
                                    <table style={{ minWidth: '100%',}} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative">
                                        <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                            <tr>
                                                <th style={{ width: "5%" }} className=' text-center'>Sr.No.</th>
                                                <th>Department Title</th>
                                                <th>Department Description</th>
                                                <th>HOD Name</th>
                                                { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                <th width={120} className=' text-center'>Action</th>)}
                                            </tr>
                                        </thead>
                                        {this.state.rows?.length === 0 ?
                                        <tbody>
                                            <tr>
                                                <td colSpan={5}>
                                                    <NoRecords />
                                                </td>
                                            </tr>
                                        </tbody>:
                                        <tbody>
                                            {
                                                this.state.rows.map((row,idx) => {
                                                    return <tr key={row.department_id}>
                                                        <td className=' text-center'>{idx+1}</td>
                                                        <td>{row.department_title}</td>
                                                        <td>{row.department_description}</td>
                                                        <td>{row.employee_label[0].ot_employee_name || "not Assign"}</td>
                                                        { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                        <td className='d-flex justify-content-around'>
                                                            { this.state.decodedData?.includes(3) && (
                                                                // <button type='button' onClick={() => this.GetInfo(row) } className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                <IconButton 
                                                                loading={this.state.loadingInfo === row?.department_id }
                                                                onClick={() => { this.GetInfo(row); }} type='primary' icon='ri-edit-box-line' tooltipName='Edit' tooltipPosition='bottom' />)}
                                                            { this.state.decodedData?.includes(4) && (
                                                                // <button onClick={() => this.handleDelete(row.department_id)} className="btn-icon btn btn-sm btn-outline-danger"> <i className="ri-delete-bin-line"></i> </button>)}
                                                                <IconButton 
                                                                loading={this.state.loadingDelete }
                                                                onClick={() => { this.handleDelete(row.department_id); }} type='danger' icon='ri-delete-bin-line' tooltipName='Delete' tooltipPosition='bottom' />)}
                                                        </td>)}
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                        }
                                    </table>
                                </div>
                                <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} name="prev" type="button" onClick={(e) => this.handlePrev("2")} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select name="total_pages" className="form-select" onChange={(e) => this.handleChange(e,"2")}>
                                            {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                            <option value={`${this.state.rows?.length}`}>All</option>
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>Limit {option}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} name="next" type="button" onClick={(e) => this.handleNext("2")} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                </div>
                            </div>
                            {this.state.isDepartmentModal && (
                                <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}>
                                    <div className="m-auto mt-3 w-modal">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">Department</h5>
                                            <button disabled={this.state.postLoading} onClick={() => { if(!this.state.postLoading){ this.setState({ isDepartmentModal:!this.state.isDepartmentModal },()=> this.resetForm()) } }} className="btn-close" aria-label="Close"/>
                                        </div>
                                        <div className="modal-body pt-0">
                                            <form className="row">
                                                <div className="col-md-6 ">
                                                    <label>Select HOD</label>
                                                    <Select 
                                                        onChange={(selectedOption) => this.handleSelectChange('hod_employee_id', selectedOption)}
                                                        placeholder={`Select Employee`} 
                                                        options={this.state.employee_verified_row} 
                                                        value={this.state.hod_employee_id ? this.state.employee_verified_row.find(option => option.value === this.state.hod_employee_id) : null}
                                                        isDisabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="department_title" className="form-label">Department title</label>
                                                    <input
                                                        type="text"
                                                        className={`form-control ${errors.department_title ? 'is-invalid' : ''}`}
                                                        id="department_title"
                                                        name="department_title"
                                                        value={this.state.department_title}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Department Title"
                                                    />
                                                    {errors.department_title && <div className="text-danger">{errors.department_title}</div>}
                                                </div>
                                                <div className="col-md-12 mt-3">
                                                    <label htmlFor="department_description" className="form-label">Department description</label>
                                                    <textarea
                                                        type="text"
                                                        className={`form-control ${errors.department_description ? 'is-invalid' : ''}`}
                                                        id="department_description"
                                                        name="department_description"
                                                        value={this.state.department_description}
                                                        disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                        onChange={this.handleInputChange}
                                                        placeholder="Enter Department Title"
                                                    />
                                                    {errors.department_description && <div className="text-danger">{errors.department_description}</div>}
                                                </div>
                                                { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                <div className="col-md-12 mt-5">
                                                    {
                                                        // this.state.department_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                        !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=>this.handleSubmit(e))
                                                            }}
                                                            loading={this.state.postLoading} loadingMessage='Loading'
                                                            disabled={!this.state.department_id}
                                                            buttonName={'Update'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />) : (
                                                            <SubmitButton onClick={(e)=>{ 
                                                                this.setState({postLoading:true},()=>this.handleSubmit(e))
                                                            }}
                                                            loading={this.state.postLoading} loadingMessage='Loading'
                                                            buttonName={this.state.department_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                            type='primary' iconSide='left' />)
                                                    }
                                                </div>)}
                                            </form>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withRouter(Department);



